import React, { useState, useEffect } from 'react';
import { Trophy, Medal } from 'lucide-react';
import adminService from '../services/adminService';

const PrizeInfo = () => {
  const [prizeInfo, setPrizeInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPrizeInfo = async () => {
      try {
        const data = await adminService.getPrizeInfo();
        setPrizeInfo(data);
      } catch (error) {
        console.error('Error fetching prize info:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPrizeInfo();
  }, []);

  if (loading) {
    return <div className="animate-pulse h-32 bg-gray-200 rounded-lg"></div>;
  }

  if (!prizeInfo) {
    return null;
  }

  return (
    <div className="bg-gradient-to-r from-primary to-primary-dark rounded-xl shadow-lg p-6 text-white mb-8">
      <h2 className="text-2xl font-bold mb-2 flex items-center">
        <Trophy className="w-7 h-7 mr-2" aria-hidden="true" /> Premiação do Bolão
      </h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
        <div className="bg-white rounded-lg p-4 text-center shadow-inner transform hover:scale-105 transition">
          <p className="text-primary text-sm uppercase font-semibold">Total Arrecadado</p>
          <p className="text-3xl font-bold mt-1 text-green-900">R$ {prizeInfo.totalCollected}</p>
          <p className="text-xs text-primary mt-2">{prizeInfo.verifiedUsersCount} participantes confirmados</p>
        </div>
        
        <div className="bg-yellow-400 bg-opacity-90 rounded-lg p-4 text-center text-yellow-900 shadow-inner transform hover:scale-105 transition">
          <p className="text-sm uppercase font-bold flex items-center justify-center gap-1"><Medal className="w-4 h-4" aria-label="1º lugar" /> 1º Lugar ({prizeInfo.percentages.first}%)</p>
          <p className="text-2xl font-black mt-1">R$ {prizeInfo.prizeFirst}</p>
        </div>
        
        <div className="bg-gray-300 bg-opacity-90 rounded-lg p-4 text-center text-gray-800 shadow-inner transform hover:scale-105 transition">
          <p className="text-sm uppercase font-bold flex items-center justify-center gap-1"><Medal className="w-4 h-4" aria-label="2º lugar" /> 2º Lugar ({prizeInfo.percentages.second}%)</p>
          <p className="text-2xl font-black mt-1">R$ {prizeInfo.prizeSecond}</p>
        </div>
        
        <div className="bg-yellow-700 bg-opacity-90 rounded-lg p-4 text-center text-orange-100 shadow-inner transform hover:scale-105 transition">
          <p className="text-sm uppercase font-bold flex items-center justify-center gap-1"><Medal className="w-4 h-4" aria-label="3º lugar" /> 3º Lugar ({prizeInfo.percentages.third}%)</p>
          <p className="text-2xl font-black mt-1">R$ {prizeInfo.prizeThird}</p>
        </div>
      </div>
      
      <p className="text-xs text-green-200 mt-4 text-center">
        * A premiação total é calculada com base no valor de R$ {prizeInfo.poolFee} por participante com pagamento verificado.
      </p>
    </div>
  );
};

export default PrizeInfo;
